import { render, staticRenderFns } from "./lstProjectParticipant.vue?vue&type=template&id=5b208884&"
import script from "./lstProjectParticipant.vue?vue&type=script&lang=js&"
export * from "./lstProjectParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports